import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/API/api.service';

@Component({
  selector: 'app-favorite-products',
  templateUrl: './favorite-products.component.html',
  styleUrl: './favorite-products.component.scss'
})
export class FavoriteProductsComponent {

  showSuccess: boolean = false;
    successMsg = '';
    showError: boolean = false;
    errorMsg = '';
    favorites: any[] = [];
    isLoading = false;
  
    constructor(private api: ApiService) {}
  
    ngOnInit(): void {
      const token = localStorage.getItem('userToken');
      if (token) {
        this.loadFavorites();
      }
    }
  
    loadFavorites() {
      this.isLoading = true;
      this.api.getFavoriteProducts().subscribe({
        next: (response) => {
          this.favorites = response.data.data;
          console.log(this.favorites)
          this.isLoading = false;
        }, 
        error: (error: HttpErrorResponse) => {
          this.showError = true;
          this.errorMsg = 'حدث خطأ, برجاء المحاولة لاحقا';
          setTimeout(() => {
            this.showError = false;
            this.errorMsg = '';
          }, 3000);
          this.isLoading = false;
        }
      });
    }
  
    toggleFavorite(vendorId: number, vendor: any) {
      this.isLoading = true;
      this.api.addToFav(vendorId).subscribe({
        next: (response) => {
          vendor.isFavorite = !vendor.isFavorite;
          if (!vendor.isFavorite) {
            // Remove from favorites array if unfavorited
            this.favorites = this.favorites.filter(v => v.id !== vendorId);
          }
          this.showSuccess = true;
          this.successMsg = vendor.isFavorite ? 'تمت الإضافة إلى المفضلة' : 'تمت الإزالة من المفضلة';
          setTimeout(() => {
            this.showSuccess = false;
            this.successMsg = '';
          }, 2000);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.showError = true;
          this.errorMsg = 'حدث خطأ أثناء التحديث';
          setTimeout(() => {
            this.showError = false;
            this.errorMsg = '';
          }, 3000);
          this.isLoading = false;
        }
      });
    }
  
    handleImageError(event: Event) {
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = './assets/img/default-vendor.jpg';
    }
  
    goBack() {
      history.back();
    }
}
